import { useState, useRef, FC, RefObject } from "react";
import { Paper, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from "@mui/material";
import { PaperProps } from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
import { TimekeeperService } from "services/TimekeeperService";

interface AddHolidayProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    reloading: () => void,
    selected: any;
    setSelected: () => void;
}

function PaperComponent(props: PaperProps) {
    const nodeRef = useRef<HTMLDivElement>(null);
    return (
        <Draggable
            nodeRef={nodeRef as RefObject<HTMLDivElement>}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const DeleteHoliday: FC<AddHolidayProps> = ({ open, setOpen, reloading, selected, setSelected }) => {
    const tk = new TimekeeperService()
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()

    const DeleteHoliday = async () => {
        setLoading(true)
        try {
            await tk.holiday.deleteHoliday(selected[0]?.id)
            enqueueSnackbar(t('settings.holidays.alerts.delete_holiday.message'), { variant: 'success' })
            reloading()
            setLoading(false)
            setOpen(false)
            setSelected()
        } catch (error) {
            console.error('Error creating holiday:', error)
            enqueueSnackbar(t('settings.holidays.alerts.error_delete_holiday.message'), { variant: 'error' })
        } finally {
            setLoading(false)
        }
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            PaperComponent={PaperComponent}
            maxWidth="sm"
            fullWidth
            aria-labelledby="draggable-dialog-title"
            aria-describedby="draggable-alert-dialog-description"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{t('settings.holidays.modals.titles.delete')}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <h4>{t('settings.holidays.modals.alerts.delete_confirm.message')}</h4>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => DeleteHoliday()} color="error" variant="contained" loading={loading} disableElevation>
                    {t('settings.holidays.modals.alerts.delete_confirm.buttons.delete')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export { DeleteHoliday }